/* ============================================================================
   Projectagram theme — storefront behavior (vanilla, no dependencies).
   Reimplements the prototype's React interactivity:
   cart drawer, AJAX add-to-cart, mobile menu, FAQ accordion, PDP.
   Cart updates use Shopify's Section Rendering API to re-render the drawer.
   ========================================================================== */
(function () {
  'use strict';

  var routes = (window.theme && window.theme.routes) || {
    cart_add: '/cart/add', cart_change: '/cart/change', cart: '/cart'
  };

  var body = document.body;

  /* ---- helpers ---------------------------------------------------------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function lockScroll(on) { body.style.overflow = on ? 'hidden' : ''; }

  /* ---- analytics -------------------------------------------------------- */
  /* Publish a namespaced storefront event onto Shopify Customer Events; a
     custom Web Pixel forwards `projectagram:*` to PostHog (project 465129).
     Best-effort — analytics must never block the UI. Keep names in lockstep
     with the builder's taxonomy (see builder/lib/analytics/posthog.ts). */
  function track(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish(name, data || {});
      }
    } catch (err) { /* never block UX for analytics */ }
  }

  /* ---- cart drawer ------------------------------------------------------ */
  function drawer() { return $('[data-cart-drawer]'); }
  function scrim() { return $('[data-cart-scrim]'); }

  function openCart() {
    var d = drawer(), s = scrim();
    if (!d) return;
    d.classList.add('open');
    d.setAttribute('aria-hidden', 'false');
    if (s) s.classList.add('open');
    lockScroll(true);
  }
  function closeCart() {
    var d = drawer(), s = scrim();
    if (d) { d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); }
    if (s) s.classList.remove('open');
    if (!menuIsOpen()) lockScroll(false);
  }

  function updateCartCount(n) {
    $all('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      if (n > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    });
  }

  /* Replace drawer contents from a re-rendered 'cart-drawer' section string. */
  function applyCartSection(html) {
    if (!html) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('[data-cart-contents]');
    var live = $('[data-cart-contents]');
    if (fresh && live) live.innerHTML = fresh.innerHTML;
    var meta = $('[data-cart-meta]');
    if (meta) updateCartCount(parseInt(meta.getAttribute('data-count'), 10) || 0);
  }

  function cartRequest(url, payload) {
    payload.sections = ['cart-drawer'];
    payload.sections_url = window.location.pathname;
    return fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); });
  }

  function addToCart(variantId, quantity) {
    if (!variantId) return;
    cartRequest(routes.cart_add, { items: [{ id: variantId, quantity: quantity || 1 }] })
      .then(function (res) {
        if (!res.ok) { alert((res.data && res.data.description) || 'Could not add to cart.'); return; }
        if (res.data.sections) applyCartSection(res.data.sections['cart-drawer']);
        openCart();
      })
      .catch(function () { alert('Could not add to cart.'); });
  }

  function changeLine(line, quantity) {
    cartRequest(routes.cart_change, { line: line, quantity: quantity })
      .then(function (res) {
        if (res.data && res.data.sections) applyCartSection(res.data.sections['cart-drawer']);
      });
  }

  /* ---- mobile menu ------------------------------------------------------ */
  function menu() { return $('[data-mobile-menu]'); }
  function menuIsOpen() { var m = menu(); return m && m.classList.contains('open'); }
  function toggleMenu(force) {
    var m = menu(), btn = $('[data-menu-toggle]');
    if (!m) return;
    var open = typeof force === 'boolean' ? force : !m.classList.contains('open');
    m.classList.toggle('open', open);
    m.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (btn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.innerHTML = open
        ? '<svg class="lucide" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>'
        : '<svg class="lucide" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="4" x2="20" y1="12" y2="12"/><line x1="4" x2="20" y1="6" y2="6"/><line x1="4" x2="20" y1="18" y2="18"/></svg>';
    }
    lockScroll(open);
  }

  /* ---- PDP quantity + variant ------------------------------------------ */
  function pdpQty(stepEl, dir) {
    var wrap = stepEl.closest('[data-pdp-qty]');
    var valEl = $('[data-qty-value]', wrap);
    var input = $('[data-qty-input]', wrap.closest('form'));
    var n = Math.max(1, (parseInt(valEl.textContent, 10) || 1) + dir);
    valEl.textContent = n;
    if (input) input.value = n;
  }

  /* ---- hero video (inline) --------------------------------------------- */
  function heroEmbedFor(url) {
    var yt = url.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
    var vimeo = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    var el;
    if (yt) {
      el = document.createElement('iframe');
      el.src = 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0&playsinline=1';
    } else if (vimeo) {
      el = document.createElement('iframe');
      el.src = 'https://player.vimeo.com/video/' + vimeo[1] + '?autoplay=1';
    } else if (/\.(mp4|webm|mov|m4v)(\?|#|$)/i.test(url)) {
      el = document.createElement('video');
      el.className = 'hero-video';
      el.src = url;
      el.controls = true; el.autoplay = true; el.playsInline = true;
      el.setAttribute('playsinline', '');
      return el;
    } else {
      el = document.createElement('iframe');
      el.src = url;
    }
    el.className = 'hero-embed';
    el.setAttribute('title', 'Video');
    el.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture; encrypted-media');
    el.setAttribute('allowfullscreen', '');
    return el;
  }
  function playHeroVideo(btn) {
    var frame = btn.closest('.frame');
    var url = btn.getAttribute('data-video-url');
    if (!frame || !url || frame.querySelector('.hero-embed, .hero-video')) return;
    frame.appendChild(heroEmbedFor(url));
    btn.setAttribute('hidden', '');
    track('projectagram:hero_video_play', { video_url: url });
  }

  /* ---- event delegation ------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    // Nav engagement — any header/menu link (logo, desktop nav, create CTA,
    // mobile menu links). Non-intercepting: log and let normal navigation run.
    var navLink = t.closest('[data-header] a[href]');
    if (navLink) {
      track('projectagram:nav_click', {
        label: (navLink.textContent || '').trim(),
        href: navLink.getAttribute('href')
      });
    }

    var openBtn = t.closest('[data-cart-open]');
    if (openBtn) { e.preventDefault(); track('projectagram:cart_opened'); openCart(); return; }

    if (t.closest('[data-cart-close]') || t.closest('[data-cart-scrim]')) { closeCart(); return; }

    // Hero video — play inline inside the 4:5 frame (no new tab)
    var heroPlay = t.closest('[data-hero-play]');
    if (heroPlay) {
      e.preventDefault();
      playHeroVideo(heroPlay);
      return;
    }

    // Empty-cart "Add a projector" — reuse the variant the header/hero CTA is bound to.
    var addDefault = t.closest('[data-add-to-cart-default]');
    if (addDefault) {
      e.preventDefault();
      var src = document.querySelector('[data-add-to-cart][data-variant-id]');
      var vid = src && src.getAttribute('data-variant-id');
      if (vid) { addToCart(vid, 1); } else { window.location.href = '/'; }
      return;
    }

    var add = t.closest('[data-add-to-cart]');
    if (add) {
      e.preventDefault();
      addToCart(add.getAttribute('data-variant-id'), 1);
      if (add.hasAttribute('data-menu-link')) toggleMenu(false);
      return;
    }

    var menuToggle = t.closest('[data-menu-toggle]');
    if (menuToggle) { e.preventDefault(); toggleMenu(); if (menuIsOpen()) track('projectagram:menu_opened'); return; }

    if (t.closest('[data-menu-link]') && !t.closest('[data-add-to-cart]')) { toggleMenu(false); }

    // Cart drawer line controls
    var line = t.closest('[data-cart-line]');
    if (line) {
      var lineIndex = parseInt(line.getAttribute('data-cart-line'), 10);
      var qtyEl = $('[data-qty-value]', line);
      var current = qtyEl ? parseInt(qtyEl.textContent, 10) || 1 : 1;
      if (t.closest('[data-qty-up]')) { changeLine(lineIndex, current + 1); return; }
      if (t.closest('[data-qty-down]')) { changeLine(lineIndex, Math.max(0, current - 1)); return; }
      if (t.closest('[data-qty-remove]')) { changeLine(lineIndex, 0); return; }
    }

    // PDP qty steppers
    var step = t.closest('[data-qty-step]');
    if (step) { e.preventDefault(); pdpQty(step, parseInt(step.getAttribute('data-qty-step'), 10)); return; }

    // PDP thumbnail swap
    var thumb = t.closest('[data-pdp-thumb]');
    if (thumb) {
      var main = $('#PdpMainImage');
      if (main) { main.src = thumb.getAttribute('data-full'); main.srcset = ''; }
      return;
    }

    // FAQ accordion (single-open)
    var faqQ = t.closest('[data-faq-q]');
    if (faqQ) {
      var item = faqQ.closest('[data-faq-item]');
      var wasOpen = item.classList.contains('open');
      $all('[data-faq-item]', faqQ.closest('[data-faq]')).forEach(function (it) {
        it.classList.remove('open');
        var q = $('[data-faq-q]', it); if (q) q.setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        item.classList.add('open'); faqQ.setAttribute('aria-expanded', 'true');
        track('projectagram:faq_opened', { question: (faqQ.textContent || '').trim() });
      }
      return;
    }
  });

  // Product form submit → AJAX add
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var idField = form.querySelector('[name="id"]');
    var qtyField = form.querySelector('[name="quantity"]');
    addToCart(idField && idField.value, (qtyField && parseInt(qtyField.value, 10)) || 1);
  });

  // PDP variant change → update price + form id
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-pdp-variant]');
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    var priceEl = $('[data-pdp-price]');
    var compareEl = $('[data-pdp-compare]');
    if (priceEl && opt.getAttribute('data-price')) priceEl.textContent = opt.getAttribute('data-price');
    if (compareEl) {
      var c = opt.getAttribute('data-compare');
      if (c && c !== '' && c !== priceEl.textContent) { compareEl.textContent = c; compareEl.hidden = false; }
      else { compareEl.hidden = true; }
    }
  });

  // ESC closes drawer / menu
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (drawer() && drawer().classList.contains('open')) closeCart();
      if (menuIsOpen()) toggleMenu(false);
    }
  });
})();
